import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import useAvailabilityState from '@/state/availabilityState';
import asyncWait from '@/utils/asyncWait';
import { watchImmediate } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAvailabilityHoursSelect',
  emits: ['hours'],
  setup(__props, { emit }) {

const { availability } = useAvailabilityState();

const number = ref(`${availability.value?.availableHoursPerWeek ?? 20}`);
const isError = ref(false);



const triggerError = async () => {
  isError.value = true;
  await asyncWait(500);
  isError.value = false;
};

watchImmediate(number, (newValue) => {
  const v = +newValue;
  if (v > 60) {
    number.value = '60';
    triggerError();
  } else if (v < 1) {
    number.value = '1';
    triggerError();
  } else {
    emit('hours', v);
  }
});

return { __sfc: true,availability, number, isError, emit, triggerError }
}

})